import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from "@ckeditor/ckeditor5-ui/src/button/buttonview";
import VueLinkCommand from './VueLinkCommand';
import VueLinkModal from "@/components/ckeditor/modals/vueLink.vue";
import config from "@/components/ckeditor/config";
import linkIcon from "@ckeditor/ckeditor5-link/theme/icons/link.svg";

export default class VueLink extends Plugin {
    init() {
        this._defineSchema();
        this._defineConverters();

        this.editor.ui.componentFactory.add("vueLink", () => {
            const button = new ButtonView();
            button.set({
                label: 'Permanent Link',
                icon: linkIcon,
                //withText: true,
                isEnabled: true //TODO: Control this based on when most content should be disabled or not. ie. Is in Source editing mode?
            });

            button.on("execute", () => {
                const oruga = config.vueContext.config.globalProperties.$oruga;

                const selectedTextArray = [];
                for (const item of this.editor.model.document.selection.getFirstRange().getItems())
                    selectedTextArray.push(item.data);

                const selectedText = selectedTextArray.join(' ');

                oruga.modal.open({
                    component: VueLinkModal,
                    trapFocus: true,
                    props: { selectedText: selectedText },
                    events: {
                        execute: (result) => {
                            this.editor.execute("insertVueLink", result);
                            this.editor.editing.view.focus();
                            result.close();
                        }
                    }
                });
            });

            //Registers the command we run from the vue modal.
            this.editor.commands.add('insertVueLink', new VueLinkCommand(this.editor));
            return button;
        });
    }

    _defineSchema() {
        const schema = this.editor.model.schema;
        schema.extend("$text", {
            allowAttributes: ["router-link", "to", "primea", "primetarget", "primedl"]
        })
    }
    _defineConverters() {
        const conversion = this.editor.conversion;
        //router-link tag
        conversion.for("downcast").attributeToElement({
            model: "routerLink",
            view: (modelAttributeValue, conversionApi) => {
                const { writer } = conversionApi;
                return writer.createAttributeElement("router-link", {
                    to: modelAttributeValue
                });
            }
        });

        conversion.for("upcast").elementToAttribute({
            view: {
                name: "router-link",
                attributes: ["to"]
            },
            model: {
                key: "routerLink",
                value: viewElement => {
                    return viewElement.getAttribute("to");
                }
            }
        });

    }

}
